import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { PhoneSelectFormikField } from '../../../../../Phone'
import { getApplicantFormOptionalLabel } from '../../../../../RentalPortalApplicant'
import { APPLICANT_FORM_FIELD_NAME_PHONE } from '../../RentalPortalApplicantForm.constants'

function PhoneField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <PhoneSelectFormikField
      controlProps={{ borderless: !isMobileScreenSize }}
      fieldComponentProps={{
        label: getApplicantFormOptionalLabel({
          label: t('Inhabitant.PhoneLabelKey'),
          t,
        }),
        shouldAdaptToMobileScreen: true,
      }}
      name={APPLICANT_FORM_FIELD_NAME_PHONE}
    />
  )
}

export default PhoneField
